module.exports = __webpack_public_path__ + "static/background-1-dc9665d52715c244295ba6e7a0177ffd.jpg";